const STORAGE_KEY = "gmail_inbox_state";

export const shuffleArray = (arr) => {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const loadPersistedFlags = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const persistFlags = (emails) => {
  try {
    const flags = emails.map(({ id, starred, read, deleted, archived }) => ({
      id,
      starred,
      read,
      deleted,
      archived,
    }));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(flags));
  } catch {
    // storage full or unavailable
  }
};

export const mergeWithPersistedFlags = (rawEmails, persistedFlags) => {
  const flagMap = {};
  persistedFlags.forEach((f) => {
    flagMap[f.id] = f;
  });

  return rawEmails.map((email) => {
    const flags = flagMap[email.id];
    return {
      ...email,
      starred: flags ? flags.starred : false,
      read: flags ? flags.read : false,
      deleted: flags ? flags.deleted : false,
      archived: flags ? !!flags.archived : false,
      selected: false,
    };
  });
};
